import { useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

const useIsMobile = () => {
  const theme = useTheme()
  const isScreenSizeMd = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isNotDesktop = useMediaQuery(theme.breakpoints.down('xl'));

  useEffect(() => {
 
  }, [isScreenSizeMd]);

  return {
    isMobile: isScreenSizeMd,
    isNotDesktop,
    isTablet
  };
}

export default useIsMobile;